var $ = require('jquery');

module.exports = function(tl, el, label) {
	tl.staggerFromTo( $(el).find('.head__page__close path').get().reverse(), 0.6, {
		drawSVG:"0% 0%"
	}, {
		drawSVG:"0% 100%",
		ease: Power2.easeOut
	}, 0.15, label );
};